import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'search_users_by';
export const useSearchUsersByTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    input: {
      placeholder: 'Email или имя от 3 символов',
    },
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    input: {
      placeholder: 'Email or name from 3 characters',
    },
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    input: {
      placeholder: 'Email ou nome a partir de 3 caracteres',
    },
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    input: {
      placeholder: 'Email o nombre desde 3 caracteres',
    },
  },
}) as Record<string, unknown>;
